import { cn } from '@/lib/cn';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost';
export type ButtonSize = 'md' | 'lg';

const BASE =
  'inline-flex items-center justify-center gap-2 rounded-md font-medium no-underline ' +
  'transition-colors duration-150 disabled:cursor-not-allowed disabled:opacity-60';

const VARIANTS: Record<ButtonVariant, string> = {
  primary: 'bg-accent-solid text-accent-contrast hover:bg-accent-solid-hover',
  secondary: 'bg-surface text-text border border-line hover:bg-surface-muted',
  ghost: 'bg-transparent text-muted hover:bg-surface-muted hover:text-text',
};

// Both sizes clear the 44px minimum target recommended by WCAG 2.2.
const SIZES: Record<ButtonSize, string> = {
  md: 'min-h-11 px-5 py-2.5 text-sm',
  lg: 'min-h-12 px-6 py-3 text-base',
};

export function buttonClasses(
  variant: ButtonVariant = 'primary',
  size: ButtonSize = 'md',
  className?: string,
): string {
  return cn(BASE, VARIANTS[variant], SIZES[size], className);
}
